import { BaseEntityState, createInitialBaseState } from '../base-store/base.state'
import { Role } from '../interfaces/role'

export type RoleState = BaseEntityState<Role>

export const initialRoleState = createInitialBaseState<Role>([])
